export const PERFORMANCE_BENCHMARK_TOOLTIP_TEXT =
  "Green: Tracking towards goal\nYellow: Tracking near goal\nRed: Not tracking towards goal";

export const NATIONAL_PERFORMANCE_TEXT = {
  title: "National Performance",
  subtitle: "Percent to Goal by Territory",
};

export const REGIONAL_PERFORMANCE_TEXT = {
  title: "Regional Performance",
  subtitle: "Percent to Goal by Territory (Southeast Region)",
};
